const _excluded = ["customGroups"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useRef, useState } from 'react';
import _isEqual from 'lodash/isEqual';
import { ModalReact, ModalType } from 'common/components/modal';
import { type Button, ButtonReact } from 'common/components/button';
import { useReportLayoutManager } from 'common/contexts/react/report-layout-manager-context';
import { Segmentation } from 'common/types/reports/query';
import { PropertyType } from 'common/report/constants';
import { ButtonTheme } from 'common/components/button/constants';
import { SvgIconReact, SvgIconType } from 'common/components/svg-icon';
import { useTranslation } from 'common/i18n/hooks';
import { propertiesUtils } from 'common/report/util/properties';
import { ControlBarReact } from 'common/widgets/control-bar';
import { SwitchEl } from 'common/components/switch';
import { Bucket, StringBucketType } from 'common/widgets/bucket-pane/types';
import { useStagedState } from 'common/hooks/useStagedState';
import { DateBucketPaneReact, DateBucketPaneTimeGroup } from 'common/widgets/bucket-pane/date-bucket-pane';
import { isSegmentEntry, QueryBucketableEntry } from 'common/query-builder/query-entry-section/types';
import { getCustomBucketAttributes } from 'common/query-builder/query-entry-section/util/group-data';
import { useQueryContextManager } from 'common/contexts/react/query-context-manager';
import { NumericBucketPaneReact } from 'common/widgets/bucket-pane/numeric-bucket-pane';
import { ToggleReact } from 'common/components/toggle';
import { SelectEvent, ToggleTheme } from 'common/components/toggle/types';
import { usePropertyEvents } from 'common/hooks/usePropertyEvents';
import styles from './index.module.styl';
// eslint-disable-next-line import/no-cycle -- string buckets render qes currently
import { StringBuckets } from './types/string';
export function GroupDataSidebar(props: {
  entry: QueryBucketableEntry;
  eventNames: string[];
  entryIdx: number;
  propertyType: PropertyType;
  propertyIcon: SvgIconType;
  onClose: () => void;
  onUpdate: (segment: Segmentation) => void;
}) {
  var _queryContextManager$, _propertyEvents$data, _property$customGroup;
  const queryContextManager = useQueryContextManager();
  const bucketAttributes = getCustomBucketAttributes({
    entry: props.entry,
    eventNames: props.eventNames || [],
    defaultBucket: isSegmentEntry(props.entry) ? (_queryContextManager$ = queryContextManager.segmentationMetadatas) === null || _queryContextManager$ === void 0 || (_queryContextManager$ = _queryContextManager$[props.entryIdx]) === null || _queryContextManager$ === void 0 ? void 0 : _queryContextManager$.numericBucket : undefined
  });
  const property = props.entry.event as Segmentation;
  const propertyEvents = usePropertyEvents({
    name: (property === null || property === void 0 ? void 0 : property.propertyName) as string
  }, {
    enabled: !!property && !property.customPropertyId && !property.customProperty && typeof property.propertyName === "string"
  });
  const textAnalysisEvents = ((_propertyEvents$data = propertyEvents.data) === null || _propertyEvents$data === void 0 ? void 0 : _propertyEvents$data.filter(event => event.is_text_analysis_event)) || [];
  const isOnTextAnalysisEvent = !!textAnalysisEvents.length;
  const [segment, setSegment] = useStagedState(property, props.onUpdate);
  const [isTextAnalysis, setIsTextAnalysis] = useState(((_property$customGroup = property.customGroups) === null || _property$customGroup === void 0 ? void 0 : _property$customGroup.type) === StringBucketType.TextAnalysis);
  const [validBucket, setValidBucket] = useState(true);
  const submitButton = useRef<Button | null>(null);
  const i18n = useTranslation();
  const {
    t
  } = i18n;
  const reportLayoutManager = useReportLayoutManager();
  const hasChanges = useMemo(() => {
    return !_isEqual(segment, property);
  }, [segment, property]);
  const hasCustomBucket = !!segment.customBucket || !!segment.customGroups;
  const propertyName = propertiesUtils.renameProperty(property.propertyName, property.resourceType, i18n);
  const supportsTextAnalysis = isTextAnalysis || props.propertyType === PropertyType.String && isOnTextAnalysisEvent;
  const applyBucketSelections = () => {
    setSegment(segment, true);
  };
  const onKeyUp = (ev: React.KeyboardEvent) => {
    if (ev.key === "Enter" && validBucket) {
      applyBucketSelections();
    }
  };
  const onClickReset = () => {
    setSegment(_objectSpread(_objectSpread({}, segment), {}, {
      customBucket: undefined,
      customGroups: undefined
    }), true);
  };
  const handleBucketUpdate = (_ref: {
    bucket: Bucket;
    isValid: boolean;
  }) => {
    let {
      bucket,
      isValid
    }: {
      bucket: Bucket;
      isValid: boolean;
    } = _ref;
    setSegment(_objectSpread(_objectSpread({}, segment), {}, {
      customBucket: bucket
    }));
    setValidBucket(isValid);
  };
  const handleUnitUpdate = (_ref2: {
    focusSubmit: boolean;
    isValid: boolean;
    unit: DateBucketPaneTimeGroup;
  }) => {
    var _submitButton$current, _submitButton$current2;
    let {
      focusSubmit,
      isValid,
      unit
    }: {
      focusSubmit: boolean;
      isValid: boolean;
      unit: DateBucketPaneTimeGroup;
    } = _ref2;
    focusSubmit && ((_submitButton$current = submitButton.current) === null || _submitButton$current === void 0 || (_submitButton$current2 = _submitButton$current.focus) === null || _submitButton$current2 === void 0 ? void 0 : _submitButton$current2.call(_submitButton$current));
    if (segment) {
      setSegment(_objectSpread(_objectSpread({}, segment), {}, {
        unit: unit as Segmentation[`unit`]
      }));
    }
    setValidBucket(isValid);
  };
  const segmentParams = (() => {
    let params: {
      segment: Segmentation | null;
      listProperty?: Segmentation;
    } = {
      segment
    };
    if (segment !== null && segment !== void 0 && segment.listItemGroup) {
      // For list of objects, we pass segment.listItemGroup as the segment (and include the outer customGroups).
      // listProperty is also needed so the appropriate values query can be made using the listProperty
      params = {
        segment: _objectSpread(_objectSpread({}, segment.listItemGroup), segment.customGroups ? {
          customGroups: segment.customGroups
        } : {}),
        listProperty: segment
      };
    }
    return params;
  })();
  return <ModalReact tabIndex={-1} hideBackdrop hideCloseButton modalType={ModalType.RightDrawer} open data-sentry-element="ModalReact" data-sentry-component="GroupDataSidebar" data-sentry-source-file="index.tsx">
      <div className={styles.container} style={{
      width: reportLayoutManager.getUserSidebarWidth()
    }}>
        <div className={styles.header}>
          <ButtonReact icon='arrow-left' theme={ButtonTheme.Tertiary} onClick={props.onClose} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx" />
          <h2 className={styles.headerText}>{t("query-builder.actions.group-data")}</h2>
          <SvgIconReact className={styles.headerIcon} icon='caret-right' data-sentry-element="SvgIconReact" data-sentry-source-file="index.tsx" />
          <SvgIconReact className={styles.headerIcon} icon={props.propertyIcon} data-sentry-element="SvgIconReact" data-sentry-source-file="index.tsx" />
          <span className={styles.headerText}>{propertyName}</span>
          {isTextAnalysis && <ControlBarReact className={styles.headerOverflow} theme={ButtonTheme.Tertiary} overflowIcon='ellipsis' overflowMenuHeight={0} overflowMenuWidth={240} overflowControls={[{
          items: [{
            label: t("query-builder.buckets.mutually-exclusive"),
            isDisabled: true,
            actionsRenderer: () => SwitchEl({
              attrs: {
                disabled: true,
                on: true
              }
            })
          }, {
            label: t("query-builder.buckets.group-remaining"),
            isDisabled: true,
            actionsRenderer: () => SwitchEl({
              attrs: {
                disabled: true,
                on: false
              }
            })
          }]
        }]} />}
        </div>
        <div className={styles.content} onKeyUp={onKeyUp}>
          {supportsTextAnalysis && <ToggleReact selected={isTextAnalysis ? "text-analysis" : "standard"} className={styles.fullWidth} theme={ToggleTheme.TabBar} options={[{
          label: "Standard",
          value: "standard",
          icon: "type-text"
        }, {
          label: "Text Analysis",
          value: "text-analysis",
          icon: "spark"
        }]} onSelect={ev => setIsTextAnalysis((ev as SelectEvent<string>).detail.selected === "text-analysis")} />}
          {(props.propertyType === PropertyType.String || props.propertyType === PropertyType.List) && segmentParams.segment && <StringBuckets eventNames={props.eventNames || []} textAnalysisEvent={textAnalysisEvents[0]} isTextAnalysis={isTextAnalysis} segment={segmentParams.segment} listProperty={segmentParams.listProperty} onUpdate={(newSegment, isValid) => {
          if (segment !== null && segment !== void 0 && segment.listItemGroup) {
            // For list of objects, the segment passed to `StringBucketPaneEl` is segment.listItemGroup, so
            // we use the emitted segment to update segment.listItemGroup
            const {
                customGroups
              } = newSegment,
              listItemGroup = _objectWithoutProperties(newSegment, _excluded);
            newSegment = _objectSpread(_objectSpread({}, segment), {}, {
              listItemGroup,
              customGroups
            });
          }
          setSegment(newSegment);
          setValidBucket(isValid);
        }} />}
          {props.propertyType === PropertyType.Number && <NumericBucketPaneReact className={styles.fullWidth} useNewDesign {...bucketAttributes} selectedBucket={segment.customBucket || bucketAttributes.selectedBucket} onUpdate={handleBucketUpdate} />}
          {props.propertyType === PropertyType.Datetime && <DateBucketPaneReact onUpdate={handleUnitUpdate} unit={segment.unit as DateBucketPaneTimeGroup} />}
        </div>
        <div className={styles.footer}>
          <ButtonReact theme={ButtonTheme.Tertiary} onClick={onClickReset} disabled={!hasCustomBucket} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
            {t("common.reset")}
          </ButtonReact>
          <ButtonReact ref={submitButton as any} className={styles.applyButton} theme={ButtonTheme.Primary} onClick={applyBucketSelections} disabled={!hasChanges || !validBucket} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
            {t("query-builder.buckets.apply-groups")}
          </ButtonReact>
        </div>
      </div>
    </ModalReact>;
}